import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { RatingScoreBar } from '../../../primitives/Rating/ScoreBar/index.js';
import { LabelSmallBold } from '../../../primitives/Typography/index.js';
export const ScoreBarWithLabel = /*#__PURE__*/_styled(forwardRef(function ScoreBarWithLabel({
  label,
  percentage,
  sentiment,
  size,
  ...restProps
}, ref) {
  return _jsxs("div", {
    ref: ref,
    ...restProps,
    children: [_jsx(LabelSmallBold, {
      children: label
    }), _jsx(RatingScoreBar, {
      percentage: percentage,
      sentiment: sentiment,
      size: size
    })]
  });
}), process.env.NODE_ENV === "production" ? {
  target: "e1uxjmez0"
} : {
  target: "e1uxjmez0",
  label: "ScoreBarWithLabel"
})(process.env.NODE_ENV === "production" ? {
  name: "1yydxi7",
  styles: "display:flex;align-items:center;gap:8px"
} : {
  name: "1yydxi7",
  styles: "display:flex;align-items:center;gap:8px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjb3JlQmFyV2l0aExhYmVsLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU9JIiwiZmlsZSI6IlNjb3JlQmFyV2l0aExhYmVsLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3gsIGpzeHMgYXMgX2pzeHMgfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBSYXRpbmdTY29yZUJhciB9IGZyb20gJy4uLy4uLy4uL3ByaW1pdGl2ZXMvUmF0aW5nL1Njb3JlQmFyL2luZGV4LmpzJztcbmltcG9ydCB7IExhYmVsU21hbGxCb2xkIH0gZnJvbSAnLi4vLi4vLi4vcHJpbWl0aXZlcy9UeXBvZ3JhcGh5L2luZGV4LmpzJztcbmV4cG9ydCBjb25zdCBTY29yZUJhcldpdGhMYWJlbCA9IHN0eWxlZChmb3J3YXJkUmVmKGZ1bmN0aW9uIFNjb3JlQmFyV2l0aExhYmVsKHsgbGFiZWwsIHBlcmNlbnRhZ2UsIHNlbnRpbWVudCwgc2l6ZSwgLi4ucmVzdFByb3BzIH0sIHJlZikge1xuICAgIHJldHVybiAoX2pzeHMoXCJkaXZcIiwgeyByZWY6IHJlZiwgLi4ucmVzdFByb3BzLCBjaGlsZHJlbjogW19qc3goTGFiZWxTbWFsbEJvbGQsIHsgY2hpbGRyZW46IGxhYmVsIH0pLCBfanN4KFJhdGluZ1Njb3JlQmFyLCB7IHBlcmNlbnRhZ2U6IHBlcmNlbnRhZ2UsIHNlbnRpbWVudDogc2VudGltZW50LCBzaXplOiBzaXplIH0pXSB9KSk7XG59KSkgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuICBnYXA6IDhweDtcbmA7XG4vLyMgc291cmNlTWFwcGluZ1VSTD1TY29yZUJhcldpdGhMYWJlbC5qcy5tYXAiXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});